import { COLOR1, COLOR2 } from '../../../constants';

export const ContactInformationStyles = {
  contact_stepper: {
    width: '100%',
    margin: '37px 30px 40px 50px',
    '@media (max-width:960px)': {
      margin: '37px 50px 45px 50px',
    },
    '@media (max-width:650px)': {
      margin: '25px',
    },
  },

  consent_message: {
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '26px',
    '@media (max-width:960px)': {
      marginBottom: '5px',
    },
  },

  contact_container: {
    paddingTop: '25px',
    paddingRight: '10px',
    paddingBottom: '0px',
    paddingLeft: '31px',
    '@media (max-width:960px)': {
      paddingTop: '20px',
      paddingRight: '25px',
      paddingBottom: '20px',
      paddingLeft: '25px',
    },
    '@media (max-width:599px)': {
      padding: '0px',
    },
  },

  contact_grid_margin: {
    boxSizing: 'border-box',
    border: '1px solid #D0D0D0',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
    borderRadius: '6px',
    '@media (max-width:599px)': {
      border: 'none',
      boxShadow: 'none',
      borderRadius: '0px',
    },
  },

  gridStyles: {
    paddingRight: '20px',
    marginBottom: '20px',
    '@media (max-width:960px)': {
      paddingRight: '0px',
    },
  },

  contact_heading: {
    textAlign: 'left',
    width: 'fit-content',
    font: 'normal normal bold 24px/23px TTNormsProBold',
    letterSpacing: '0.14px',
    color: COLOR1,
    opacity: 1,
    '@media (max-width:600px)': {
      font: 'normal normal 700 22px/32px TTNormsProBold',
      letterSpacing: '0.11px',
      color: COLOR1,
      margin: '0',
      marginBottom: '5px',
      marginTop: 0,
    },
  },

  inputs_grid_margin: {
    marginTop: '21px',
    '@media (max-width:600px)': {
      marginTop: '20px',
      // display: 'flex',
      // flexDirection: 'column',
      // width: '100%',
    },
  },

  margin_adjust_for_top_grid: {
    marginTop: '21px',
    '@media (max-width:960px)': {
      marginTop: '20px',
    },
  },

  contact_field_padding_left: {
    paddingLeft: '20px',
    '@media (max-width:959px)': {
      paddingLeft: '0',
    },
  },

  error_message: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    position: 'relative',
    top: '3px',
    display: 'block',
  },

  email_grid: {
    marginTop: '21px',
    '@media (max-width:650px)': {
      marginTop: '15px',
    },
  },

  contact_terms: {
    font: 'normal normal 400 16px/18px Arial',
    color: COLOR1,
    opacity: 1,
    letterSpacing: '0.1px',
  },

  continue_grid: {
    marginTop: '45px',
    marginBottom: '30px',
    justifyContent: 'flex-end',
    '@media (max-width:650px)': {
      marginTop: '35px',
      marginBottom: '20px',
    },
  },

  image_Style: {
    maxWidth: '320px',
    width: '100%',
  },

  educativaHeading: {
    font: 'normal normal 700 24px/100% TTNormsProBold',
    letterSpacing: '0px',
    color: COLOR1,
    textAlign: 'left',
  },

  educativaContainer: {
    padding: '30px',
    gap: '30px',
    '@media (max-width:599px)': {
      padding: 0,
    },
  },
};
